"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdministratorStatus = void 0;

var common_1 = require("./common");

var AdministratorStatus;

(function (AdministratorStatus) {
  AdministratorStatus["ACTIVE"] = "active";
  AdministratorStatus["BANNED"] = "banned";
})(AdministratorStatus = exports.AdministratorStatus || (exports.AdministratorStatus = {}));